"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassportScoreVerifiableTestFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PassportScoreVerifiableTestFactory = /** @class */ (function (_super) {
    __extends(PassportScoreVerifiableTestFactory, _super);
    function PassportScoreVerifiableTestFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PassportScoreVerifiableTestFactory.prototype.deploy = function (_passportScoresContract, overrides) {
        return _super.prototype.deploy.call(this, _passportScoresContract, overrides || {});
    };
    PassportScoreVerifiableTestFactory.prototype.getDeployTransaction = function (_passportScoresContract, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _passportScoresContract, overrides || {});
    };
    PassportScoreVerifiableTestFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PassportScoreVerifiableTestFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PassportScoreVerifiableTestFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PassportScoreVerifiableTestFactory;
}(contracts_1.ContractFactory));
exports.PassportScoreVerifiableTestFactory = PassportScoreVerifiableTestFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_passportScoresContract",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DidNotRevert",
        type: "event",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "_mandatoryProof",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "_enforceSameCaller",
                type: "bool",
            },
        ],
        name: "doSomething",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "passportScoresContract",
        outputs: [
            {
                internalType: "contract ISapphirePassportScores",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
